module.exports = __webpack_public_path__ + "img/logo_kbai_grey.381e3733.png";